import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4l0np8cc8r: FaireBrandEntity = {
  token: "b_4l0np8cc8r",
  type: "brand",
  name: "WerkShoppe",
  avatarUrl:
    "https://cdn.faire.com/fastly/1c22a36fa0f9637e9355b276b116a974204f4805982b97d4d5ef6708ad743945.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c54ef45b91c8137b803b6a9595ead1fbdeccb73d11774528e09e9bad91eba42e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1c22a36fa0f9637e9355b276b116a974204f4805982b97d4d5ef6708ad743945.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c54ef45b91c8137b803b6a9595ead1fbdeccb73d11774528e09e9bad91eba42e.jpeg",
  location: "Palm Springs, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 117,
  isTopShop: true,
  isInsider: true,
  description:
    "We’re WerkShoppe…cool, colorful and always fun! \n\nWe see WerkShoppe as an art & design community first, where artistic collaborations with emerging, independent and established artists are turned into an array of beautiful products.\n\nWe began this journey in 2020 when we discovered that we shared a love of making jigsaw puzzles with our moms when we were growing up. Our backgrounds in home fashion consumer products, from wall art to decorative accessories and giftware, provided us with the tools (and guts) to start our new company. \n\nFrom our distinctive jigsaw puzzles, now in updated slipcase drawer boxes, to new introductions in sustainable products like our hard-working microfiber textile collections and giftable cotton tea towels, we like to think we are creating a connection between our artists, their beautiful creations and you. \n\nWe hope you will share the WerkShoppe experience with others. And thanks to our customers’ support of WerkShoppe, we are able to give back to nationwide art education programs; this makes everyone feel good! Art brings us so much happiness and we want you to feel that way too. We love art, we love what we do, and we hope we can share that love with you. \n\nxo, \nAnn Marie & Wayne\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:55.588Z",
    importedBy: "entity-db-cli",
  },
};
